/** 
* 自动生成文件，请勿修改 
* @name: 系统:用户-部门关系管理模块
* @description: 用户-部门关系管理-增删改查
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:9条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const userDepartRelation = { 
	/** 1 summary:查询-单条(根据主键)	method:post */ 
	queryOne : new APIObject("/api/userDepartRelation/queryOne.do"), 
	/** 2 summary:删除-单条	method:post */ 
	delete : new APIObject("/api/userDepartRelation/delete.do"), 
	/** 3 summary:查询-全部不分页(根据userId,roleId)	method:post */ 
	queryAll : new APIObject("/api/userDepartRelation/queryAll.do"), 
	/** 4 summary:绑定-一次性选择一个用户，勾选多个部门进性绑定（老关系会被删除）	method:post */ 
	bindDepart : new APIObject("/api/userDepartRelation/bindDepart.do"), 
	/** 5 summary:保存/修改-批量	method:post */ 
	batchSaveOrUpd : new APIObject("/api/userDepartRelation/batchSaveOrUpd.do"), 
	/** 6 summary:查询-分页(根据userId,departmentId)	method:post */ 
	queryPage : new APIObject("/api/userDepartRelation/queryPage.do"), 
	/** 7 summary:绑定-一次性选择一个部门，勾选多个用户进性绑定	method:post */ 
	bindUser : new APIObject("/api/userDepartRelation/bindUser.do"), 
	/** 8 summary:保存/修改-单条	method:post */ 
	saveOrUpd : new APIObject("/api/userDepartRelation/saveOrUpd.do"), 
	/** 9 summary:删除-批量	method:post */ 
	batchDelete : new APIObject("/api/userDepartRelation/batchDelete.do"), 
};
export default userDepartRelation;